export default __webpack_public_path__ + "static/media/git-original.53130bb0.svg";